(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-test-ls"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPdpLs2() {
  // ── Hoist modals to <body> so they escape any theme stacking context ──────
  ['ls2-szm','ls2-jm','ls2-lb'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
  });

  // ── Carousel (mobile) ───────────────────────────────────────────────────
  var track   = document.getElementById('ls2-track');
  var dots    = document.querySelectorAll('.ls2-car__dot');
  var carPrev = document.getElementById('ls2-car-prev');
  var carNext = document.getElementById('ls2-car-next');
  var cur     = 0;
  var total   = dots.length || 1;

  function goTo(i) {
    cur = i;
    if (track) track.style.transform = 'translateX(-' + (i * 100) + '%)';
    dots.forEach(function (d, j) { d.classList.toggle('ls2-car__dot--on', j === i); });
    var slides = track ? track.querySelectorAll('.ls2-car__slide') : [];
    slides.forEach(function (s, j) {
      var vid = s.querySelector('video');
      if (vid) { if (j === i) vid.play(); else vid.pause(); }
    });
    if (carPrev) carPrev.disabled = (i === 0);
    if (carNext) carNext.disabled = (i === total - 1);
  }

  dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(this.dataset.i)); }); });
  if (carPrev) carPrev.addEventListener('click', function () { if (cur > 0) goTo(cur - 1); });
  if (carNext) carNext.addEventListener('click', function () { if (cur < total - 1) goTo(cur + 1); });

  var car = document.getElementById('ls2-car');
  if (car) {
    var tx = 0, ty = 0, sw = false;
    car.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; sw = false; }, { passive: true });
    car.addEventListener('touchmove', function (e) {
      var dx = Math.abs(e.touches[0].clientX - tx), dy = Math.abs(e.touches[0].clientY - ty);
      if (dx > dy && dx > 8) { sw = true; e.preventDefault(); }
    }, { passive: false });
    car.addEventListener('touchend', function (e) {
      if (!sw) return;
      var diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        if (diff > 0 && cur < total - 1) goTo(cur + 1);
        else if (diff < 0 && cur > 0)   goTo(cur - 1);
      }
    }, { passive: true });
  }

  // Wishlist
  var wish = document.getElementById('ls2-wish');
  if (wish) {
    var liked = false;
    wish.addEventListener('click', function () {
      liked = !liked;
      var p = this.querySelector('path');
      if (p) p.setAttribute('fill', liked ? '#d32f8a' : 'none');
    });
  }

  // ── Accordion ───────────────────────────────────────────────────────────
  document.querySelectorAll('.ls2-acc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body  = this.nextElementSibling;
      var isOpen = body.classList.contains('ls2-acc-body--open');
      document.querySelectorAll('.ls2-acc-body').forEach(function (b) { b.classList.remove('ls2-acc-body--open'); });
      document.querySelectorAll('.ls2-acc-btn').forEach(function (b) { b.classList.remove('ls2-acc-btn--open'); b.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) {
        body.classList.add('ls2-acc-body--open');
        this.classList.add('ls2-acc-btn--open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── Variant selection ────────────────────────────────────────────────────
  var varSel      = document.getElementById('ls2-var-sel');
  var atcBtn      = document.getElementById('ls2-atc');
  var atcPriceEl  = document.getElementById('ls2-atc-price');
  var priceEl     = document.getElementById('ls2-price');
  var priceWasEl  = document.getElementById('ls2-price-was');
  var stickyPrice = document.getElementById('ls2-sticky-price');
  var stickyBtnPrice = document.getElementById('ls2-sticky-btn-price');
  var swatchName  = document.getElementById('ls2-swatch-name');

  function updateVariant() {
    if (!varSel) return;
    var activeSwatch = document.querySelector('.ls2-swatch--on');
    var activeSize   = document.querySelector('.ls2-size-btn--on');
    var hasSwatches  = document.querySelector('.ls2-swatch') !== null;

    // Determine which option index size controls via data-option-index,
    // falling back to: option2 if swatches exist, option1 if not.
    var sizeOptIdx = 1;
    if (activeSize && activeSize.dataset.optionIndex) {
      var parsed = parseInt(activeSize.dataset.optionIndex, 10);
      if (parsed >= 1) sizeOptIdx = parsed;
    } else {
      sizeOptIdx = hasSwatches ? 2 : 1;
    }

    var found = null;
    for (var i = 0; i < varSel.options.length; i++) {
      var opt = varSel.options[i];
      var ok = true;
      if (activeSwatch && opt.dataset.option1 !== activeSwatch.dataset.value) ok = false;
      if (activeSize   && opt.dataset['option' + sizeOptIdx] !== activeSize.dataset.value) ok = false;
      if (ok) { found = opt; break; }
    }
    if (!found) return;

    varSel.value = found.value;
    var avail = found.dataset.available === 'true';
    var price = found.dataset.price;

    if (priceEl)     priceEl.textContent     = price;
    if (stickyPrice) stickyPrice.textContent = price;
    if (stickyBtnPrice) stickyBtnPrice.textContent = ' · ' + price;
    if (atcPriceEl)  atcPriceEl.textContent  = price;
    if (atcBtn) {
      atcBtn.disabled = !avail;
      atcBtn.innerHTML = avail
        ? (atcBtn.dataset.atcLabel + ' — <span id="ls2-atc-price">' + price + '</span>')
        : atcBtn.dataset.soldOutLabel;
      atcPriceEl = document.getElementById('ls2-atc-price');
    }

    var bisSlot = document.getElementById('ls2-bis-slot');
    if (bisSlot) { if (avail) bisSlot.setAttribute('hidden', ''); else bisSlot.removeAttribute('hidden'); }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', found.value);
    window.history.replaceState({}, '', url.toString());

    if (found.dataset.option1 && swatchName) swatchName.textContent = found.dataset.option1;
  }

  // Swatch clicks
  document.querySelectorAll('.ls2-swatch').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelectorAll('.ls2-swatch').forEach(function (s) { s.classList.remove('ls2-swatch--on'); });
      this.classList.add('ls2-swatch--on');
      if (swatchName) swatchName.textContent = this.dataset.value;
      updateVariant();
    });
  });

  // Size btn clicks
  document.querySelectorAll('.ls2-size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ls2-size-btn').forEach(function (b) { b.classList.remove('ls2-size-btn--on'); });
      this.classList.add('ls2-size-btn--on');
      updateVariant();
      // mirror to modal
      var v = this.dataset.value;
      document.querySelectorAll('.ls2-szm-btn').forEach(function (b) { b.classList.toggle('ls2-szm-btn--on', b.dataset.value === v); });
      var ma = document.getElementById('ls2-szm-atc');
      if (ma) ma.disabled = atcBtn ? atcBtn.disabled : false;
    });
  });

  // ── ATC ─────────────────────────────────────────────────────────────────
  function openCart() {
    stickyDisable();
    var cartBtn = document.querySelector('.js-drawer-open-cart');
    if (cartBtn) { cartBtn.click(); return; }
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    var d = document.getElementById('CartDrawer');
    if (d) { d.classList.add('drawer--is-open'); document.documentElement.classList.add('js-drawer-open'); }
  }

  // ── Sticky bar: disable while cart drawer is open ────────────────────────
  var stickyEl = document.getElementById('ls2-sticky');
  function stickyDisable() { if (stickyEl) { stickyEl.style.pointerEvents = 'none'; stickyEl.style.visibility = 'hidden'; } }
  function stickyRestore() { if (stickyEl) { stickyEl.style.pointerEvents = ''; stickyEl.style.visibility = ''; } }

  // Compensate for fixed positioning: pad the bottom of the page so content
  // isn't hidden behind the bar. Recalculate on resize (font size / safe area changes).
  function updateStickyPad() {
    if (!stickyEl) return;
    document.documentElement.style.setProperty('--ls2-sticky-h', stickyEl.offsetHeight + 'px');
  }
  updateStickyPad();
  window.addEventListener('resize', updateStickyPad);
  function isCartOpen() {
    var cd = document.getElementById('CartDrawer');
    if (cd && (cd.classList.contains('drawer--is-open') || cd.getAttribute('aria-hidden') === 'false' || cd.hasAttribute('open'))) return true;
    return document.body.classList.contains('js-drawer-open') ||
           document.body.classList.contains('js-drawer-open-cart') ||
           document.documentElement.classList.contains('js-drawer-open');
  }
  // Observe CartDrawer directly for most reliable detection
  var cartDrawerEl = document.getElementById('CartDrawer');
  if (cartDrawerEl) {
    new MutationObserver(function() { if (isCartOpen()) stickyDisable(); else stickyRestore(); })
      .observe(cartDrawerEl, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
  }
  // Also watch body/html class as fallback
  function onBodyClassChange() { if (isCartOpen()) stickyDisable(); else stickyRestore(); }
  new MutationObserver(onBodyClassChange).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(onBodyClassChange).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  function doATC(btn) {
    if (!varSel) return;
    var vid = varSel.value;
    if (!vid) return;
    var orig = btn.innerHTML;
    btn.classList.add('ls2-loading');
    btn.innerHTML = '<span class="ls2-spin"></span>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.disabled = false;
      btn.classList.remove('ls2-loading');
      btn.innerHTML = orig;
      stickyDisable();

      if (window.jQuery) {
        // Trigger added.ajaxProduct so Impulse refreshes the cart drawer content.
        // Prevent the scroll-to-top it normally causes by blocking $.fn.animate
        // calls for scrollTop and immediately restoring the scroll position.
        var savedScroll = window.pageYOffset;
        var origAnimate = jQuery.fn.animate;
        jQuery.fn.animate = function(props) {
          if (props && !isNaN(props.scrollTop)) return this;
          return origAnimate.apply(this, arguments);
        };
        jQuery('body').trigger('added.ajaxProduct', jQuery(btn));
        setTimeout(function() {
          jQuery.fn.animate = origAnimate;
          window.scrollTo(0, savedScroll);
        }, 800);
      } else {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count').forEach(function(el) { el.textContent = cart.item_count; });
          openCart();
        }).catch(function() { openCart(); });
      }
    })
    .catch(function() { btn.disabled = false; btn.classList.remove('ls2-loading'); btn.innerHTML = orig; });
  }

  var form = document.getElementById('ls2-form');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); if (atcBtn && !atcBtn.disabled) doATC(atcBtn); });

  // ── Back-in-Stock: move app-injected button into buy box slot ────────────
  (function moveBIS() {
    var slot = document.getElementById('ls2-bis-slot');
    if (!slot) return;
    // Look for the BIS button the app injects (typically after the form or in body)
    // Try common selectors used by BIS apps; MutationObserver catches late injection
    function tryMove() {
      if (slot.childElementCount > 0) return; // already moved
      var candidates = [
        document.querySelector('[id*="bis_trigger"]'),
        document.querySelector('[id*="BIS_trigger"]'),
        document.querySelector('[class*="bis-container"]'),
        document.querySelector('[class*="bis_trigger"]'),
        document.querySelector('[data-bis]'),
      ];
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i] && !slot.contains(candidates[i])) {
          slot.appendChild(candidates[i]);
          return;
        }
      }
    }
    tryMove();
    var obs = new MutationObserver(tryMove);
    obs.observe(document.body, { childList: true, subtree: true });
  })();

  // ── Sticky + size modal ──────────────────────────────────────────────────
  var szm   = document.getElementById('ls2-szm');
  var szmBg = document.getElementById('ls2-szm-bg');
  var szmCl = document.getElementById('ls2-szm-close');
  var szmAt = document.getElementById('ls2-szm-atc');

  function openSzm()  { if (szm) { closeJm(); closeSgModal(); szm.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; } }
  function closeSzm() { if (szm) { szm.setAttribute('hidden', ''); document.body.style.overflow = ''; } }

  var stickyAtc = document.getElementById('ls2-sticky-atc');
  if (stickyAtc) stickyAtc.addEventListener('click', function () {
    if (isCartOpen()) return;
    if (szm) openSzm(); else if (atcBtn && !atcBtn.disabled) doATC(atcBtn);
  });
  if (szmBg) szmBg.addEventListener('click', closeSzm);
  if (szmCl) szmCl.addEventListener('click', closeSzm);

  document.querySelectorAll('.ls2-szm-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ls2-szm-btn').forEach(function (b) { b.classList.remove('ls2-szm-btn--on'); });
      this.classList.add('ls2-szm-btn--on');
      var v = this.dataset.value;
      document.querySelectorAll('.ls2-size-btn').forEach(function (b) { b.classList.toggle('ls2-size-btn--on', b.dataset.value === v); });
      updateVariant();
      if (szmAt) szmAt.disabled = atcBtn ? atcBtn.disabled : false;
    });
  });
  if (szmAt) szmAt.addEventListener('click', function () { closeSzm(); if (atcBtn && !atcBtn.disabled) doATC(atcBtn); });

  // ── Reviews modal ────────────────────────────────────────────────────────
  var jm   = document.getElementById('ls2-jm');
  var jmBg = document.getElementById('ls2-jm-bg');
  var jmCl = document.getElementById('ls2-jm-close');
  var jmInit = false;

  function openJm() {
    if (!jm) return;
    closeSzm(); closeSgModal();
    jm.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    if (!jmInit) {
      jmInit = true;
      if (window.jdgm && window.jdgm.customWidgetLoader) window.jdgm.customWidgetLoader();
      else if (window.jdgm && window.jdgm.loadFromPage) window.jdgm.loadFromPage();
    }
  }
  function closeJm() { if (!jm) return; jm.setAttribute('hidden', ''); document.body.style.overflow = ''; }

  [document.getElementById('ls2-rev-open'), document.getElementById('ls2-reviews-all')].forEach(function (b) { if (b) b.addEventListener('click', openJm); });
  document.addEventListener('click', function(e) {
    if (e.target.closest('.ls2-jdgm-badge .jdgm__rev-count, .ls2-jdgm-badge .jdgm-prev-badge__text a')) {
      e.preventDefault(); e.stopPropagation(); openJm();
    }
  });
  if (jmBg) jmBg.addEventListener('click', closeJm);
  if (jmCl) jmCl.addEventListener('click', closeJm);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeJm(); closeSzm(); closeSgModal(); }
  });

  // ── Size guide modal (exact copy from pdp-template-pr-v1) ────────────────
  var sgModal     = document.getElementById('pdp-sg-modal');
  var sgOpenBtn   = document.getElementById('pdp-size-guide-btn');
  var sgCloseBtn  = document.getElementById('pdp-sg-modal-close');
  var sgBackdrop  = document.getElementById('pdp-sg-modal-backdrop');

  function openSgModal() {
    if (!sgModal) return;
    closeJm(); closeSzm();
    sgModal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }
  function closeSgModal() {
    if (!sgModal) return;
    sgModal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  if (sgOpenBtn)  sgOpenBtn.addEventListener('click', function(e) { e.stopPropagation(); openSgModal(); });
  if (sgCloseBtn) sgCloseBtn.addEventListener('click', closeSgModal);
  if (sgBackdrop) sgBackdrop.addEventListener('click', closeSgModal);

  } // end initPdpLs2

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpLs2);
  } else {
    initPdpLs2();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
